export var TagType;
(function (TagType) {
    TagType[TagType["LOT"] = 1] = "LOT";
    TagType[TagType["SERIAL"] = 2] = "SERIAL";
    /** Generic untracked on-hand balance (warehouse receiving, cycle count, etc.) */
    TagType[TagType["STOCK"] = 3] = "STOCK";
})(TagType || (TagType = {}));
//# sourceMappingURL=tag-type.js.map